import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// Créer une instance axios avec configuration
const assistantV2Api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercepteur pour ajouter le token JWT
assistantV2Api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("smarthr_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
assistantV2Api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("smarthr_token");
      localStorage.removeItem("smarthr_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

/**
 * Service pour l'Assistant IA RH V2
 */
export const assistantV2Service = {
  /**
   * Envoyer une question à l'assistant
   */
  async chat(question, conversationId = null, signal = null) {
    const response = await assistantV2Api.post(
      "/assistant-v2/chat",
      { question, conversation_id: conversationId },
      { signal }
    );
    return response.data;
  },

  /**
   * Récupérer l'historique des conversations
   */
  async getHistory(signal = null) {
    const response = await assistantV2Api.get("/assistant-v2/history", {
      signal,
    });
    return response.data;
  },

  /**
   * Récupérer les détails d'une conversation
   */
  async getConversation(conversationId, signal = null) {
    const response = await assistantV2Api.get(
      `/assistant-v2/history/${conversationId}`,
      { signal }
    );
    return response.data;
  },

  /**
   * Supprimer une conversation
   */
  async deleteConversation(conversationId, signal = null) {
    const response = await assistantV2Api.delete(
      `/assistant-v2/history/${conversationId}`,
      { signal }
    );
    return response.data;
  },

  /**
   * Supprimer tout l'historique
   */
  async deleteAllHistory(signal = null) {
    const response = await assistantV2Api.delete("/assistant-v2/history", {
      signal,
    });
    return response.data;
  },

  /**
   * Renommer une conversation
   */
  async renameConversation(conversationId, newTitle, signal = null) {
    const response = await assistantV2Api.put(
      `/assistant-v2/history/${conversationId}`,
      { title: newTitle },
      { signal }
    );
    return response.data;
  },
};

export default assistantV2Service;
